var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var filterObject = function (obj, predicate) {
    return Object.keys(obj).reduce(function (record, key) {
        var _a;
        return predicate(key, obj[key]) ? __assign(__assign({}, record), (_a = {}, _a[key] = obj[key], _a)) : record;
    }, {});
};
export var mapObject = function (obj, mapFn) {
    return Object.keys(obj).reduce(function (record, key) {
        var _a;
        return (__assign(__assign({}, record), (_a = {}, _a[key] = mapFn(key, obj[key]), _a)));
    }, {});
};
export var isEmptyObject = function (objectOrEmpty) {
    return Object.keys(objectOrEmpty).length === 0;
};
